import '../../vendor/clickmenu.js';

export const setupMenu = ($: JQueryStatic) => {
  $('.main-nav').clickMenu();
  $('.section-nav').clickMenu({ expanders: true, isAutoClose: false });
};
